import {Component} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-assistant-info-modal',
  templateUrl: './assistant-info-modal.component.html',
  styleUrls: ['./assistant-info-modal.component.scss'],
  standalone: false
})
export class AssistantInfoModalComponent {
  constructor(private modalController: ModalController) { }

  close() {
    this.modalController.dismiss();
  }
}
